import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class SubscriptionRecord extends RecordBase {

  static defaultAttributes = {
    is_active:                  true,
    name:                       '',
    lang:                       'pt-BR',
    type:                       null,
    month_price:                null,
    coin:                       'R$',
    google_month_product_id:    '',
    apple_month_product_id:     '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    if(!this._attributeNames){
      this._attributeNames = {
        id:                         t('subscription.attributes.id'),
        name:                       t('subscription.attributes.name'),
        lang:                       t('subscription.attributes.lang'),
        type:                       t('subscription.attributes.type'),
        month_price:                t('subscription.attributes.month_price'),
        coin:                       t('subscription.attributes.coin'),
        google_month_product_id:    t('subscription.attributes.google_month_product_id'),
        apple_month_product_id:     t('subscription.attributes.apple_month_product_id'),
        is_active:                  t('subscription.attributes.is_active'),
        deleted_at:                 t('subscription.attributes.deleted_at'),
        updated_at:                 t('subscription.attributes.updated_at'),
      };
    }

    return this._attributeNames;
  }

  toParams(){
    const {
      is_active,
      name,
      lang,
      type,
      month_price,
      coin,
      google_month_product_id,
      apple_month_product_id,
    } = this.toObject();

    return {
      data:{
        attributes:{
          is_active,
          name,
          lang,
          type,
          month_price,
          coin,
          google_month_product_id,
          apple_month_product_id,
        }
      }
    };
  }
}
